/**
 * Utility to extract the first name from a full name.
 * @param fullName - The full name string.
 * @returns The formatted first name.
 */
export const getFirstName = (fullName: string): string => {
  let name = fullName?.split(' ')?.[0] || '';
  name =
    name.length > 2
      ? name.charAt(0).toUpperCase() + name.substring(1).toLowerCase()
      : name;
  return name;
};
